<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
/* eslint-disable no-console */
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard",
      items: [""],
      userRole: "", 
      auths: [{username:"admin", type:"a"}, 
              {username:"891128", type:"m"}, 
              {username:"891137", type:"m"}, 
              {username:"891129", type:"m"}, 
              {username:"989858", type:"s"}, 
              {username:"288419", type:"m"}, 
              {username:"891132", type:"a"}, 
              {username:"325858", type:"m"}, 
              {username:"891133", type:"a"}, 
              {username:"555499", type:"m"}, 
              {username:"714799", type:"m"}, 
              {username:"857022", type:"m"}, 
              {username:"219031", type:"a"}, 
              {username:"891134", type:"a"}, 
              {username:"891135", type:"a"}, 
              {username:"891138", type:"s"}, 
              {username:"891139", type:"m"}, 
              {username:"891140", type:"s"}, 
              {username:"891136", type:"s"}
            ]
    };
  },
  mounted() {
    var user = JSON.parse(localStorage.getItem("user"));
    let obj = this.auths.find(o => o.username === user.username);
    this.userRole = obj.type;

    console.log(this.userRole);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('report.text')" :items="items" />
    <div class="row">

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.payment.text')}}
            </h4>
            <!-- <div class="card-text mb-2"><router-link :to="'report/payment/payment'">{{$t('report.payment.payment')}}</router-link></div> -->
            <div v-show="userRole == 'm' || userRole == 'a'" class="card-text mb-2"><router-link :to="'report/payment/detail'">{{$t('report.payment.detail')}}</router-link></div>
            <!-- <div class="card-text mb-2"><router-link :to="'report/payment/principle'">{{$t('report.payment.principle')}}</router-link></div> -->
            <!-- <div class="card-text mb-2"><router-link :to="'report/payment/receive'">{{$t('report.payment.receive')}}</router-link></div> -->
            <div v-show="userRole == 'm' || userRole == 'a'" class="card-text mb-2"><router-link :to="'report/payment/collect'">{{$t('report.payment.collect-payment')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/payment/late'">{{$t('report.payment.late')}}</router-link></div>
            <div v-show="userRole == 'm' || userRole == 'a'" class="card-text mb-2"><router-link :to="'report/payment/unit'">{{$t('report.payment.by-unit')}}</router-link></div>
            <div v-show="userRole == 'm' || userRole == 'a'" class="card-text mb-2"><router-link :to="'report/payment/unit-detail'">{{$t('report.payment.by-unit-detail')}}</router-link></div>
          </div>
        </div>
      </div>

      <div v-show="userRole == 'm' || userRole == 's'" class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.property.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/project/summary'">{{$t('report.property.brief')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/property/group-summary'">{{$t('report.property.group')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/property/detail'">{{$t('report.property.detail')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/property/price-changing'">{{$t('report.property.price_changing')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'/report/property/cancelation'">{{$t('report.property.cancelation')}}</router-link></div>
            <!-- <div class="card-text mb-2" style="color: white">report</div> -->
            <!-- <div class="card-text mb-2" style="color: white">report</div> -->
          </div>
        </div>
      </div>

      <div v-show="userRole == 'm' || userRole == 'a'" class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.pl.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/pl/all'">{{$t('report.pl.all-transaction')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/income/daily'">{{$t('report.income_expense.daily_income')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/expense/daily'">{{$t('report.income_expense.daily_expense')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/income/summary'">{{$t('report.income_expense.income-summary')}}</router-link></div>
            <!-- <div class="card-text mb-2"><router-link :to="'report/pl/leager'">{{$t('report.pl.leager')}}</router-link></div> -->
            <!-- <div class="card-text mb-2"><router-link :to="'report/pl/pl'">{{$t('report.pl.profit-lost')}}</router-link></div> -->
            <div class="card-text mb-2" style="color: white">report</div>
            <!-- <div class="card-text mb-2" style="color: white">report</div> -->

          </div>
        </div>
      </div>

      <div v-show="userRole == 'm' || userRole == 's'" class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.sold.text')}}
            </h4>
            <!-- <div class="card-text mb-2"><router-link :to="'report/sold/total'">{{$t('report.sold.total')}}</router-link></div> -->

            <div class="card-text mb-2"><router-link :to="'report/sale/detail'">{{$t('report.sale-detail.text')}}</router-link></div>
            <div v-show="userRole == 'm'" class="card-text mb-2"><router-link :to="'report/sale/unit'">{{$t('report.sale-unit.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/transfer/sale'">របាយការណ៍ផ្លាស់ប្ដូរអចលនទ្រព្យ</router-link></div>
            <div v-show="userRole == 'm'" class="card-text mb-2"><router-link :to="'report/sale/price-version'">{{$t('report.sale-stage.text')}}</router-link></div>
            <div v-show="userRole == 'm'" class="card-text mb-2"><router-link :to="'report/sale/all-price-version'">{{$t('report.sale-stage.all')}}</router-link></div>
          </div>
        </div>
      </div>

      <div v-show="userRole == 'm' || userRole == 's'" class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.booking.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/booking/expired'">{{$t('report.booking.expired')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/booking/daily'">{{$t('report.booking.daily')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.property-more.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/propertymore/adjust'">{{$t('report.property-more.adjust')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/propertymore/summary'">{{$t('report.property-more.summary')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/propertymore/sold'">{{$t('report.property-more.sold')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/propertymore/breif'">{{$t('report.property-more.breif')}}</router-link></div>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.sell-more.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/discount'">{{$t('report.sell-more.discount')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/project'">{{$t('report.sell-more.project')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/group'">{{$t('report.sell-more.group')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/daily'">{{$t('report.sell-more.daily')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/seller'">{{$t('report.sell-more.seller')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/payment'">{{$t('report.sell-more.payment')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/sellmore/detail'">{{$t('report.sell-more.detail')}}</router-link></div>
          </div>
        </div>
      </div> -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.daily.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/daily/notification'">{{$t('report.daily.notification')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/daily/customer-follow-up'">{{$t('report.daily.customer-followup')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/item/stock'">{{$t('report.text')+$t('item.item-stock')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/item/list'">{{$t('report.text')+$t('item.item-list')}}</router-link></div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.commission.text')}}
            </h4>
            <!-- <div class="card-text mb-2"><router-link :to="'report/commission/available'">{{$t('commission.report_available')}}</router-link></div> -->
            <div class="card-text mb-2"><router-link :to="'report/commission'">{{$t('commission.report_detail')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/commission/staff'">{{$t('commission.report_staff')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/commission/agency'">{{$t('commission.report_agency')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/commission/indro'">{{$t('commission.report_indro')}}</router-link></div>
            
            <!-- <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div> -->
          </div>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.payment-more.text')}}
            </h4>
            <div class="row">
              <div class="col-lg-4">
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/summary'">{{$t('report.payment-more.summary')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/late'">{{$t('report.payment-more.late-payment')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/project'">{{$t('report.payment-more.project')}}</router-link></div>

              </div>
            
              <div class="col-lg-4">
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/user'">{{$t('report.payment-more.user')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/paymentuser'">{{$t('report.payment-more.payment-by-user')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/collection'">{{$t('report.payment-more.collection')}}</router-link></div>
              </div>
            
              <div class="col-lg-4">
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/breif'">{{$t('report.payment-more.breif-collection')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'report/paymentmore/detial'">{{$t('report.payment-more.detial-collection')}}</router-link></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('document.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'general/booking/contract/3'">{{$t('property.contract')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'properties/payment_schedule'">{{$t('property.schedule')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'properties/receipt'">{{$t('property.receipt')}}</router-link></div>
          </div>
        </div>
      </div> -->
      <!-- <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              គណនេយ្យ
            </h4>
            <div class="card-text mb-2"><router-link :to="'report/accounting/leadger'">{{$t('accounting.ledger')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/accounting/trial'">{{$t('accounting.trial-balance')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'report/accounting/pnl'">{{$t('accounting.income-statement')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div> -->
    </div>
  </Layout>
</template>
